module.exports = __webpack_public_path__ + "static/media/Close.a8d1b2cc.svg";